import React, { useEffect, useState } from "react";
import { createSeparate, getDataItems } from "../../api/Separates";
import LoadingPage from "../Loading/loading";
import { useNavigate } from "react-router-dom";
import { Cookies } from "react-cookie";
import { ToastContainer, toast } from "react-toastify";
import { createResale, getItemForResale } from "../../api/Resale";

const AddResaleComponent = (props) => {
  const navigate = useNavigate();
  const cookie = new Cookies();
  const [isSuper, setIsSuper] = useState(cookie.get("isSuper"));
  const [resaleItems, setResaleItems] = useState(null);
  const [loading, setLoading] = useState();

  const [formData, setFormData] = useState({
    adname: "",
    owner: false,
    selltype: "",
    finished: "",
    type2: "",
    size: "",
    upfront: "",
    moveInDate: "",
    additionals: [],
    rooms: "",
    bathrooms: "",
    furnished: false,
    payment: "",
    price: {
      value: "",
      pricenegotiable: false,
    },
    phone: "",
    whatsapp: "",
    images: [],
    goverment: "",
    location: "",
    description: "",
    floor_level: "",
    unitCode: "",
  });

  useEffect(() => {
    getItemForResale().then((result) => {
      setResaleItems(result.data);
    });
  }, []);

  const handleChange = (e) => {
    e.target.setCustomValidity("");
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    if (files.length > 6) {
      alert("Please select a maximum of 6 images");
      return;
    }

    const validTypes = ["image/jpg", "image/png", "image/jpeg"];
    const invalidFiles = files.filter(
      (file) => !validTypes.includes(file.type),
    );

    if (invalidFiles.length > 0) {
      alert("Only JPG, PNG, or JPEG files are allowed");
      return;
    }

    setFormData((prev) => ({
      ...prev,
      images: [...prev.images, ...files],
    }));
  };

  const removeImage = (index) => {
    setFormData((prev) => ({
      ...prev,
      images: prev.images.filter((_, i) => i !== index),
    }));
  };

  const formatPrice = (value) => {
    return new Intl.NumberFormat().format(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const formBack = new FormData();
    formBack.append("adname", formData.adname);
    formBack.append("owner", formData.owner);
    formBack.append("selltype", formData.selltype);
    formBack.append("type", formData.type);
    formBack.append("finished", formData.finished);
    formBack.append("type2", formData.type2);
    formBack.append("size", formData.size);
    formBack.append("upfront", formData.upfront);
    formBack.append("moveInDate", formData.moveInDate);
    formBack.append("additionals", JSON.stringify(formData.additionals));
    formBack.append("rooms", formData.rooms);
    formBack.append("bathrooms", formData.bathrooms);
    formBack.append("furnished", formData.furnished);
    formBack.append("payment", formData.payment);
    formBack.append("price", formData.price.value);
    formBack.append("pricenegotiable", formData.price.pricenegotiable);
    formBack.append("phone", formData.phone);
    formBack.append("whatsapp", formData.whatsapp);
    formBack.append("goverment", formData.goverment);
    formBack.append("location", formData.location);
    formBack.append("description", formData.description);
    formBack.append("floor_level", formData.floor_level);
    formBack.append("unitCode", formData.unitCode);
    for (let i = 0; i < formData.images.length; i++) {
      formBack.append("images", formData.images[i]);
    }

    createResale(formBack).then((result) => {
      if (result.data.message === "Resale is created successfullly") {
        toast.success("Resale is created successfullly", {
          position: "top-right",
        });
        props.changeToView("View Resale");
      }
      setLoading(false);
    });
  };

  const inputStyle = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    border: 0,
  };

  const labelStyle = {
    display: "inline-block",
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    transition: "background-color 0.3s",
    border: "none",
    textAlign: "center",
    ":hover": {
      backgroundColor: "#45a049",
    },
  };

  const labelDeleteStyle = {
    display: "inline-block",
    padding: "10px",
    backgroundColor: "red",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    transition: "background-color 0.3s",
    border: "none",
    textAlign: "center",
    ":hover": {
      backgroundColor: "#45a049",
    },
    margin: "0px",
  };

  return (
    <>
      {resaleItems === null ? (
        <LoadingPage />
      ) : (
        <div className="add-brokers-guideline">
          <form onSubmit={handleSubmit}>
            <label htmlFor="image">Images</label>
            <div className="image-previews">
              {formData.images.map((image, imageIndex) => (
                <div key={imageIndex} className="preview-item">
                  <img
                    src={URL.createObjectURL(image)}
                    alt={`Preview ${imageIndex}`}
                  />
                  <button onClick={() => removeImage(imageIndex)}>×</button>
                </div>
              ))}
            </div>

            {formData.images.length < 6 && (
              <div className="form-group">
                <div style={{ position: "relative", marginTop: "16px" }}>
                  <input
                    type="file"
                    id="images"
                    name="images"
                    onChange={handleFileChange}
                    multiple
                    accept="image/jpg, image/png, image/jpeg"
                    style={inputStyle}
                    required
                  />
                  <label htmlFor="images" style={labelStyle}>
                    Choose Images ({6 - formData.images.length} remaining)
                  </label>
                </div>
              </div>
            )}

            <div className="form-group">
              <label htmlFor="adname">Title</label>
              <input
                type="text"
                id="adname"
                name="adname"
                value={formData.adname}
                onChange={handleChange}
                placeholder="Enter Title"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Title is required")
                }
              />
            </div>

            <div className="form-group">
              <label
                htmlFor="selltype"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                Sell type
              </label>
              <select
                className="form-select form-control form-select-lg border border-dark"
                aria-label="Select Sell type"
                name="selltype" // Changed from selltype to be more descriptive
                value={formData.selltype}
                onChange={(e) => {
                  e.target.setCustomValidity("");
                  setFormData({
                    ...formData,
                    selltype: e.target.value,
                  });
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "16px",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                }}
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Sell type is required")
                }
              >
                <option disabled value="">
                  Select Sell type
                </option>
                {resaleItems.selltypes?.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label
                htmlFor="type2"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                Type
              </label>
              <select
                className="form-select form-control form-select-lg border border-dark"
                aria-label="Select Type"
                name="type2" // Changed from type2 to be more descriptive
                value={formData.type2}
                onChange={(e) => {
                  e.target.setCustomValidity("");
                  setFormData({
                    ...formData,
                    type2: e.target.value,
                  });
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "16px",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                }}
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Type is required")
                }
              >
                <option disabled value="">
                  Select Type
                </option>
                {resaleItems.types?.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label
                htmlFor="finished"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                Finished
              </label>
              <select
                className="form-select form-control form-select-lg border border-dark"
                aria-label="Select Finished"
                name="finished" // Changed from finished to be more descriptive
                value={formData.finished}
                onChange={(e) => {
                  e.target.setCustomValidity("");
                  setFormData({
                    ...formData,
                    finished: e.target.value,
                  });
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "16px",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                }}
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Finished is required")
                }
              >
                <option disabled value="">
                  Select Finished
                </option>
                {resaleItems.finishing?.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label
                htmlFor="finished"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                Delivery
              </label>
              <select
                className="form-select form-control form-select-lg border border-dark"
                aria-label="Select Delivery"
                name="moveInDate" // Changed from finished to be more descriptive
                value={formData.moveInDate}
                onChange={(e) => {
                  e.target.setCustomValidity("");
                  setFormData({
                    ...formData,
                    moveInDate: e.target.value,
                  });
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "16px",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                }}
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Delivery is required")
                }
              >
                <option disabled value="">
                  Select Delivery
                </option>
                {resaleItems.delivery?.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div className="form-group">
                <label
                  htmlFor="rooms"
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "500",
                  }}
                >
                  Rooms
                </label>
                <select
                  className="form-select form-control form-select-lg border border-dark"
                  aria-label="Select Rooms"
                  name="rooms" // Changed from rooms to be more descriptive
                  value={formData.rooms}
                  onChange={(e) => {
                    e.target.setCustomValidity("");
                    setFormData({
                      ...formData,
                      rooms: e.target.value,
                    });
                  }}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    fontSize: "16px",
                    backgroundColor: "#fff",
                    cursor: "pointer",
                  }}
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Rooms is required")
                  }
                >
                  <option disabled value="">
                    Select Rooms
                  </option>
                  {resaleItems.rooms?.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label
                  htmlFor="bathrooms"
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "500",
                  }}
                >
                  Bathrooms
                </label>
                <select
                  className="form-select form-control form-select-lg border border-dark"
                  aria-label="Select Bathrooms"
                  name="bathrooms" // Changed from bathrooms to be more descriptive
                  value={formData.bathrooms}
                  onChange={(e) => {
                    e.target.setCustomValidity("");
                    setFormData({
                      ...formData,
                      bathrooms: e.target.value,
                    });
                  }}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    fontSize: "16px",
                    backgroundColor: "#fff",
                    cursor: "pointer",
                  }}
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Bathrooms is required")
                  }
                >
                  <option disabled value="">
                    Select Bathrooms
                  </option>
                  {resaleItems.bathrooms?.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="price">Price</label>
                <input
                  type="number"
                  id="price"
                  name="price"
                  value={formData.price.value}
                  onChange={(e) => {
                    e.target.setCustomValidity("");
                    setFormData((prev) => ({
                      ...prev,
                      price: {
                        ...prev.price,
                        value: e.target.value,
                      },
                    }));
                  }}
                  placeholder="Enter Price"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Price is required")
                  }
                />
              </div>
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="size">Area</label>
                <input
                  type="number"
                  id="size"
                  name="size"
                  value={formData.size}
                  onChange={handleChange}
                  placeholder="Enter Area"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Area is required")
                  }
                />
              </div>
            </div>

            <div className="form-group">
              <label
                htmlFor="payment"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                Payment
              </label>
              <select
                className="form-select form-control form-select-lg border border-dark"
                aria-label="Select Payment"
                name="payment" // Changed from payment to be more descriptive
                value={formData.payment}
                onChange={(e) => {
                  e.target.setCustomValidity("");
                  setFormData({
                    ...formData,
                    payment: e.target.value,
                  });
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "16px",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                }}
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Payment is required")
                }
              >
                <option disabled value="">
                  Select Payment
                </option>
                {resaleItems.payment?.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="phone">Phone number</label>
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Enter Phone number"
                  maxLength="11"
                  pattern="^01[0-2,5]\d{1,8}$"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Phone is required")
                  }
                />
              </div>
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="whatsapp">Whatsapp</label>
                <input
                  type="text"
                  id="whatsapp"
                  name="whatsapp"
                  value={formData.whatsapp}
                  onChange={handleChange}
                  placeholder="Enter Whatsapp"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Whatsapp is required")
                  }
                />
              </div>
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="floor_level">Floor level</label>
                <input
                  type="number"
                  id="floor_level"
                  name="floor_level"
                  value={formData.floor_level}
                  onChange={handleChange}
                  placeholder="Enter Floor level"
                  pattern="^\d+(\.\d{1,10})?$"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Floor level is required")
                  }
                />
              </div>

              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="upfront">Upfront</label>
                <input
                  type="number"
                  id="upfront"
                  name="upfront"
                  value={formData.upfront}
                  onChange={handleChange}
                  placeholder="Enter Upfront"
                  pattern="^\d+(\.\d{1,10})?$"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Upfront is required")
                  }
                />
              </div>
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div className="form-group">
                <label
                  htmlFor="location"
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "500",
                  }}
                >
                  Location
                </label>
                <select
                  className="form-select form-control form-select-lg border border-dark"
                  aria-label="Select Location"
                  name="location" // Changed from location to be more descriptive
                  value={formData.location}
                  onChange={(e) => {
                    e.target.setCustomValidity("");
                    setFormData({
                      ...formData,
                      location: e.target.value,
                    });
                  }}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    fontSize: "16px",
                    backgroundColor: "#fff",
                    cursor: "pointer",
                  }}
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Location is required")
                  }
                >
                  <option disabled value="">
                    Select Location
                  </option>
                  {resaleItems.locations?.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>

              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="unitCode">Unit code</label>
                <input
                  type="text"
                  id="unitCode"
                  name="unitCode"
                  value={formData.unitCode}
                  onChange={handleChange}
                  placeholder="Enter Unit code"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Unit code is required")
                  }
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="description">Description</label>
              <textarea
                type="text"
                id="description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Enter description"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Description is required")
                }
              />
            </div>

            <div
              onClick={() =>
                setFormData((prev) => ({
                  ...prev,
                  owner: !prev.owner,
                }))
              }
            >
              <input
                type="checkbox"
                checked={formData.owner}
                onChange={() => {}}
                className="client-checkbox"
              />
              <label htmlFor="owner" style={{ paddingLeft: "10px" }}>
                Owner
              </label>
            </div>

            <div
              onClick={() =>
                setFormData((prev) => ({
                  ...prev,
                  furnished: !prev.furnished,
                }))
              }
            >
              <input
                type="checkbox"
                checked={formData.furnished}
                onChange={() => {}}
                className="client-checkbox"
              />
              <label htmlFor="furnished" style={{ paddingLeft: "10px" }}>
                Furnished
              </label>
            </div>

            <div
              onClick={() =>
                setFormData((prev) => ({
                  ...prev,
                  price: {
                    ...prev.price,
                    pricenegotiable: !prev.price.pricenegotiable,
                  },
                }))
              }
            >
              <input
                type="checkbox"
                checked={formData.price.pricenegotiable}
                onChange={() => {}}
                className="client-checkbox"
              />
              <label htmlFor="pricenegotiable" style={{ paddingLeft: "10px" }}>
                Price Negotiable
              </label>
            </div>

            <div className="features-section">
              {resaleItems.additionals?.map((item, index) => {
                const isSelected = formData.additionals.some(
                  (additional) => additional === item,
                );

                return (
                  <div
                    className={`${
                      isSelected ? "features-item-selected" : "features-item"
                    }`}
                    key={index}
                    onClick={() => {
                      setFormData((prev) => {
                        const isSelected = prev.additionals.includes(item);

                        return {
                          ...prev,
                          additionals: isSelected
                            ? prev.additionals.filter((name) => name !== item)
                            : [...prev.additionals, item],
                        };
                      });
                    }}
                  >
                    <span className={`${isSelected ? "" : "label"}`}>
                      {item}
                    </span>
                  </div>
                );
              })}
            </div>

            {loading ? (
              <div
                style={{
                  width: "100%",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <div className="spinner"></div>
              </div>
            ) : (
              <button type="submit" className="submit-button">
                Add Resale
              </button>
            )}
          </form>
          <ToastContainer />
        </div>
      )}
    </>
  );
};

export default AddResaleComponent;
